import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import RoamlyLogo from '@/assets/about/outdoorsy-group/roamly-logo.svg';
import CancellationPolicy from '@/graphql/components/route/listing/HouseRules/CancellationPolicy';
import { getListingHouseRules } from '@/redux/selectors/listing/houseRules';
import { getListingId } from '@/redux/selectors/listing/page';
import { getQuoteData } from '@/redux/selectors/quote';

export const AutoHouseRulesContainer = () => {
  const rentalId = useSelector(getListingId);
  const quote = useSelector(getQuoteData);
  const houseRules = useSelector(getListingHouseRules);

  const hasSiblingQuote = !!quote?.sibling_quote_group_id;

  if (!houseRules?.cancel_policy) {
    return null;
  }

  return (
    <>
      <CancellationPolicy
        rentalId={rentalId}
        policy={houseRules.cancel_policy}
        hasSiblingQuote={hasSiblingQuote}
      />

      <div className="flex items-center mt-4 gap-2">
        <Text variant={ETextStyleVariant.MediumRegular}>
          <FormattedMessage defaultMessage="Insuranced by" id="SeQPOQ" />
        </Text>

        <RoamlyLogo className="w-20 mt-1" />
      </div>
    </>
  );
};
